import React from "react";
import * as styles from "./MethodRow.module.scss";
import { cx } from "class-variance-authority";
import { Skeleton } from "@picklebet/ui";

type MethodRowProps = {
  as?: "div" | "button";
  icon: React.ReactNode;
  label: React.ReactNode;
  sublabel?: React.ReactNode;
  trailing?: React.ReactNode;
  disabled?: boolean;
} & React.HTMLAttributes<HTMLElement>;

export const MethodRowSkeleton = () => {
  return (
    <Skeleton size="lg" className={styles.containerSkeleton}>
      <Skeleton mode="light" className={styles.iconSkeleton} />
      <Skeleton mode="light" span="third" className={styles.labelSkeleton} />
    </Skeleton>
  );
};

export const MethodRow = ({
  as: Slot = "div",
  icon,
  label,
  sublabel,
  trailing,
  className,
  disabled,
  ...rest
}: MethodRowProps) => {
  return (
    <Slot
      {...(Slot === "button" ? { type: "button" as const } : {})}
      className={cx(styles.container, className, disabled && styles.disabled)}
      disabled={disabled}
      {...rest}
    >
      {icon}

      <div className={styles.labels}>
        <span className={styles.label}>{label}</span>
        {sublabel && <span className={styles.sublabel}>{sublabel}</span>}
      </div>

      {trailing && <div className={styles.trailing}>{trailing}</div>}
    </Slot>
  );
};
